import React, { useState } from 'react';
import './WitchProfile.css';

const WitchProfile = () => {
  const [answers, setAnswers] = useState({});
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [result, setResult] = useState(null);
  const [showCourse, setShowCourse] = useState(false);

  const questions = [
    {
      id: 1,
      question: "Kun olet uupunut, mikä palauttaa sinut parhaiten?",
      options: [
        { value: 'A', text: 'Metsä, kasvit, hiljaisuus' },
        { value: 'B', text: 'Kynttilä, rukous, rauhallinen musiikki' },
        { value: 'C', text: 'Kehollinen liike, tanssi, kosketus' },
        { value: 'D', text: 'Päiväkirja, syvä keskustelu, pimeä ilta' },
        { value: 'E', text: 'Kortit, symbolit, pohdinta' },
        { value: 'F', text: 'Hoitaminen, kuuntelu, toisen auttaminen' },
        { value: 'G', text: 'Kokeilu, spontaani tekeminen' }
      ]
    },
    {
      id: 2,
      question: "Mikä teema toistuu elämässäsi?",
      options: [
        { value: 'A', text: 'Yhteys luontoon ja rytmeihin' },
        { value: 'B', text: 'Oikeudenmukaisuus, suojeleminen' },
        { value: 'C', text: 'Intohimo, tunne, luovuus' },
        { value: 'D', text: 'Muutos kriisien kautta' },
        { value: 'E', text: 'Merkitysten etsiminen' },
        { value: 'F', text: 'Parantaminen ja kannattelu' },
        { value: 'G', text: 'Vapaus ja rajojen rikkominen' }
      ]
    },
    {
      id: 3,
      question: "Miten lähestyt magiaa tai henkisyyttä?",
      options: [
        { value: 'A', text: 'Käytännöllisesti ja luonnon kautta' },
        { value: 'B', text: 'Eettisesti ja harkiten' },
        { value: 'C', text: 'Kehon ja energian kautta' },
        { value: 'D', text: 'Varjojen ja totuuden kautta' },
        { value: 'E', text: 'Symbolien ja ennustamisen kautta' },
        { value: 'F', text: 'Läsnäolon ja hoivan kautta' },
        { value: 'G', text: 'Intuition ja kokeilun kautta' }
      ]
    },
    {
      id: 4,
      question: "Mitä muut usein sanovat sinusta?",
      options: [
        { value: 'A', text: '"Olet rauhallinen ja maadoittava"' },
        { value: 'B', text: '"Olet luotettava ja puhdas sydämeltäsi"' },
        { value: 'C', text: '"Sinussa on vahvaa voimaa"' },
        { value: 'D', text: '"Näet syvemmälle kuin muut"' },
        { value: 'E', text: '"Tiedät asioita ilman selitystä"' },
        { value: 'F', text: '"Olo on parempi kun olet läsnä"' },
        { value: 'G', text: '"Olet erilainen ja luova"' }
      ]
    },
    {
      id: 5,
      question: "Mikä näistä kutsuu eniten?",
      options: [
        { value: 'A', text: 'Yrtit, kivet, vuodenajat' },
        { value: 'B', text: 'Suojarituaalit, valo' },
        { value: 'C', text: 'Kuu, veri, feminiininen voima' },
        { value: 'D', text: 'Alitajunta, varjotyö' },
        { value: 'E', text: 'Tarot, astrologia' },
        { value: 'F', text: 'Energiahoito, kosketus' },
        { value: 'G', text: 'Sigillit, omat rituaalit' }
      ]
    }
  ];

  const profiles = {
    'A': { emoji: '🌿', name: 'Vihreä noita', color: '#4a7c59' },
    'B': { emoji: '🤍', name: 'Valkoinen noita', color: '#e8e8e8' },
    'C': { emoji: '❤️', name: 'Punainen noita', color: '#c94a4a' },
    'D': { emoji: '🌙', name: 'Varjonoita', color: '#2d2d44' },
    'E': { emoji: '🔮', name: 'Ennustaja / Oraakkeli', color: '#7b68ee' },
    'F': { emoji: '🕯️', name: 'Parantaja', color: '#f4a460' },
    'G': { emoji: '🖤', name: 'Kaoottinen noita', color: '#1a1a1a' }
  };

  const handleAnswer = (answer) => {
    const newAnswers = { ...answers, [currentQuestion]: answer };
    setAnswers(newAnswers);

    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
    } else {
      calculateResult(newAnswers);
    }
  };

  const calculateResult = (allAnswers) => {
    const counts = {};
    Object.values(allAnswers).forEach(answer => {
      counts[answer] = (counts[answer] || 0) + 1;
    });

    const sorted = Object.entries(counts)
      .sort((a, b) => b[1] - a[1])
      .map(([letter]) => letter);

    const primary = sorted[0];
    const secondary = sorted[1] && counts[sorted[1]] === counts[primary] ? sorted[1] : null;
    const tertiary = sorted[2] && counts[sorted[2]] === counts[primary] ? sorted[2] : null;

    setResult({
      primary,
      secondary,
      tertiary,
      counts
    });
  };

  const handleRestart = () => {
    setAnswers({});
    setCurrentQuestion(0);
    setResult(null);
    setShowCourse(false);
  };

  const getProfileText = (letter) => {
    return profiles[letter];
  };

  return (
    <div className="witch-profile">
      <div className="container">
        {!result ? (
          <div className="test-section">
            <div className="test-header">
              <h1>🔮 OMAN NOITAPROFIILIN TESTI</h1>
              <p className="test-subtitle">
                Löydä oma noitaprofiilisi vastaamalla viiteen kysymykseen. Valitse jokaisessa kysymyksessä se vaihtoehto, joka tuntuu sinusta eniten oikealta.
              </p>
            </div>

            <div className="test-progress">
              <div className="progress-bar">
                <div 
                  className="progress-fill" 
                  style={{ width: `${((currentQuestion + 1) / questions.length) * 100}%` }}
                ></div>
              </div>
              <p className="progress-text">
                Kysymys {currentQuestion + 1} / {questions.length}
              </p>
            </div>

            <div className="question-card card">
              <h2 className="question-number">Kysymys {questions[currentQuestion].id}</h2>
              <h3 className="question-text">{questions[currentQuestion].question}</h3>
              <div className="options-list">
                {questions[currentQuestion].options.map((option, index) => (
                  <button
                    key={index}
                    className="option-btn"
                    onClick={() => handleAnswer(option.value)}
                  >
                    <span className="option-letter">{option.value})</span>
                    <span className="option-text">{option.text}</span>
                  </button>
                ))}
              </div>
            </div>
          </div>
        ) : (
          <div className="results-section">
            <div className="result-header">
              <h1>🧭 SINUN NOITAPROFIILISI</h1>
              <p className="result-subtitle">
                Tässä on sinun noitaprofiilisi vastaustesi perusteella
              </p>
            </div>

            <div className="result-card card">
              <div className="primary-profile">
                <div 
                  className="profile-badge" 
                  style={{ backgroundColor: `${getProfileText(result.primary).color}20`, borderColor: getProfileText(result.primary).color }}
                >
                  <span className="profile-emoji">{getProfileText(result.primary).emoji}</span>
                  <div>
                    <h2>{getProfileText(result.primary).name}</h2>
                    <p className="profile-count">({result.counts[result.primary]} vastausta)</p>
                  </div>
                </div>
              </div>

              {(result.secondary || result.tertiary) && (
                <div className="hybrid-profiles">
                  <h3 className="hybrid-title">
                    Hybridiprofiili
                  </h3>
                  <p className="hybrid-description">
                    Vastauksissasi näkyy vahvoja piirteitä useammasta profiilista. Tämä tarkoittaa, että sinulla on monipuolinen noitaprofiili, joka yhdistää eri noitapolkujen vahvuuksia.
                  </p>
                  <div className="hybrid-list">
                    {result.secondary && (
                      <div 
                        className="profile-badge small"
                        style={{ backgroundColor: `${getProfileText(result.secondary).color}20`, borderColor: getProfileText(result.secondary).color }}
                      >
                        <span className="profile-emoji">{getProfileText(result.secondary).emoji}</span>
                        <span>{getProfileText(result.secondary).name}</span>
                        <span className="profile-count">({result.counts[result.secondary]} vastausta)</span>
                      </div>
                    )}
                    {result.tertiary && (
                      <div 
                        className="profile-badge small"
                        style={{ backgroundColor: `${getProfileText(result.tertiary).color}20`, borderColor: getProfileText(result.tertiary).color }}
                      >
                        <span className="profile-emoji">{getProfileText(result.tertiary).emoji}</span>
                        <span>{getProfileText(result.tertiary).name}</span>
                        <span className="profile-count">({result.counts[result.tertiary]} vastausta)</span>
                      </div>
                    )}
                  </div>
                </div>
              )}

              <div className="result-actions">
                <button onClick={() => setShowCourse(!showCourse)} className="btn btn-primary">
                  {showCourse ? 'Piilota kurssirakenne' : 'Näytä kurssirakenne →'}
                </button>
                <button onClick={handleRestart} className="btn btn-secondary">
                  Tee testi uudelleen
                </button>
              </div>
            </div>

            {showCourse && (
              <div className="course-section">
                <div className="course-intro card">
                  <h2>📚 NOITUUSKURSSI: "LÖYDÄ OMA POLKUSI"</h2>
                  <p className="course-intro-text">
                    Tervetuloa noituuskurssille, joka auttaa sinua löytämään oman polkusi noituudessa. Kurssi on rakennettu niin, että kaikki osallistujat läpäisevät saman perusrakenteen, mutta harjoitukset ja työkalut räätälöidään jokaisen oman noitaprofiilin mukaan.
                  </p>
                  <p className="course-intro-text">
                    Tämä tarkoittaa, että sinä saat henkilökohtaisen oppimispolun, joka vastaa juuri sinun energiasi ja tapojasi lähestyä noituutta.
                  </p>
                </div>

                <div className="course-modules">
                  <div className="module card">
                    <div className="module-header">
                      <span className="module-number">1</span>
                      <h3>MITÄ NOITUUS ON</h3>
                    </div>
                    <div className="module-content">
                      <p>
                        Tässä moduulissa tutustumme noituuden perusteisiin ja siihen, mitä noituus todella on. Yhdessä pureudumme noituuden filosofiaan ja sen perusperiaatteisiin.
                      </p>
                      <h4>Moduulin sisältö:</h4>
                      <ul>
                        <li><strong>Noituus energiaa ja aikomusta:</strong> Noituus ei ole moraali tai dogma, vaan energiaa ja tietoista aikomusta. Opimme, miten noituus toimii käytännössä.</li>
                        <li><strong>Arkkityypit suuntauksina:</strong> Noitaprofiilit eivät ole kiinteitä rooleja, vaan suuntauksia, jotka auttavat sinua ymmärtämään omaa energiaasi. Voit olla monimuotoinen ja yhdistää eri profiilien piirteitä.</li>
                        <li><strong>Henkilökohtainen polku:</strong> Jokaisella on oma polkunsa noituudessa. Tässä moduulissa tutkimme, mitä tämä tarkoittaa sinulle.</li>
                      </ul>
                      <div className="module-exercise">
                        <strong>Harjoitus:</strong> Reflektoi kysymystä: "Milloin olen ollut eniten oma itseni?" Kirjoita ajatuksiasi päiväkirjaan ja pohdí, mitä tämä kertoo sinusta ja sinun energiasi.
                      </div>
                    </div>
                  </div>

                  <div className="module card">
                    <div className="module-header">
                      <span className="module-number">2</span>
                      <h3>OMA NOITAPROFIILI</h3>
                    </div>
                    <div className="module-content">
                      <p>
                        Tässä moduulissa syvennymme omaan noitaprofiiliisi. Opimme tunnistamaan profiilisi vahvuudet ja haasteet, sekä ymmärtämään, miten sinun energiasi toimii arjessa.
                      </p>
                      <h4>Moduulin sisältö:</h4>
                      <ul>
                        <li><strong>Profiilitesti ja reflektio:</strong> Analysoimme testin tuloksia yhdessä ja pohdimme, mitä ne kertovat sinusta.</li>
                        <li><strong>Profiilin vahvuudet ja varjot:</strong> Jokaisella profiililla on sekä vahvuuksia että haasteita. Opimme tunnistamaan nämä ja työskentelemään niiden kanssa.</li>
                        <li><strong>Energia arjessa:</strong> Ymmärrämme, miten sinun noitaprofiilisi näkyy päivittäisessä elämässäsi ja miten voit hyödyntää sitä.</li>
                      </ul>
                      <div className="module-exercise">
                        <strong>Harjoitus:</strong> Tee profiilikohtainen päiväkirjatehtävä. Harjoitus vaihtelee profiilisi mukaan:
                        <ul className="exercise-examples">
                          <li><strong>Vihreä noita:</strong> Kirjoita luontohavaintoja ja miten ne vaikuttavat sinuun</li>
                          <li><strong>Varjonoita:</strong> Reflektoi yhtä vaikeaa tuntea ja miten se liittyy kasvuusi</li>
                          <li><strong>Punainen noita:</strong> Tee kehollinen harjoitus ja kirjoita kokemuksestasi</li>
                          <li><strong>Muut profiilit:</strong> Saat oman profiilikohtaisen harjoituksen</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="module card">
                    <div className="module-header">
                      <span className="module-number">3</span>
                      <h3>TYÖKALUT POLKUSI MUKAAN</h3>
                    </div>
                    <div className="module-content">
                      <p>
                        Tässä moduulissa tutustumme noituuden työkaluihin. Kaikki osallistujat saavat perustyökalut, mutta painotukset ja syvennyskohteet vaihtelevat noitaprofiilin mukaan. Tämä tarkoittaa, että opit käyttämään juuri sinulle sopivia työkaluja.
                      </p>
                      <h4>Perustyökalut (kaikille):</h4>
                      <ul>
                        <li>Rituaalien perusteet</li>
                        <li>Energian työskentely</li>
                        <li>Intuition kehittäminen</li>
                        <li>Turvallisuus ja eettisyys</li>
                      </ul>
                      <h4>Profiilikohtaiset painotukset:</h4>
                      <div className="tools-table">
                        <div className="tool-row">
                          <span className="tool-emoji">🌿</span>
                          <span className="tool-profile">Vihreä noita</span>
                          <span className="tool-tools">Yrtit, maa, vuodenajat, luonnon syklit</span>
                        </div>
                        <div className="tool-row">
                          <span className="tool-emoji">🤍</span>
                          <span className="tool-profile">Valkoinen noita</span>
                          <span className="tool-tools">Suojaus, rituaalipuhdistus, valo, eettisyys</span>
                        </div>
                        <div className="tool-row">
                          <span className="tool-emoji">❤️</span>
                          <span className="tool-profile">Punainen noita</span>
                          <span className="tool-tools">Keho, kuu, energia, feminiininen voima</span>
                        </div>
                        <div className="tool-row">
                          <span className="tool-emoji">🌙</span>
                          <span className="tool-profile">Varjonoita</span>
                          <span className="tool-tools">Varjotyö, symbolit, alitajunta, muutos</span>
                        </div>
                        <div className="tool-row">
                          <span className="tool-emoji">🔮</span>
                          <span className="tool-profile">Ennustaja / Oraakkeli</span>
                          <span className="tool-tools">Tarot, astrologia, symbolit, ennustaminen</span>
                        </div>
                        <div className="tool-row">
                          <span className="tool-emoji">🕯️</span>
                          <span className="tool-profile">Parantaja</span>
                          <span className="tool-tools">Energiahoito, läsnäolo, kosketus, hoiva</span>
                        </div>
                        <div className="tool-row">
                          <span className="tool-emoji">🖤</span>
                          <span className="tool-profile">Kaoottinen noita</span>
                          <span className="tool-tools">Sigillit, intuitio, luovuus, spontaanius</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="module card">
                    <div className="module-header">
                      <span className="module-number">4</span>
                      <h3>OMAN RITUAALIN LUOMINEN</h3>
                    </div>
                    <div className="module-content">
                      <p>
                        Tämä moduuli on kurssin sydän. Tässä opit luomaan oman henkilökohtaisen rituaalisi, joka perustuu sinun noitaprofiiliisi ja tarpeisiisi.
                      </p>
                      <h4>Moduulin sisältö:</h4>
                      <ul>
                        <li><strong>Ei valmista kaavaa:</strong> Opimme, että rituaalit eivät ole kiinteitä kaavoja, vaan henkilökohtaisia ilmaisuja. Jokainen rituaali on uniikki ja rakennetaan juuri sinulle.</li>
                        <li><strong>Rituaalin rakenne:</strong> Opimme rituaalin perusosat ja miten ne yhdistetään. Tämä antaa sinulle työkalut luoda oman rituaalisi.</li>
                        <li><strong>Profiilisi mukauttaminen:</strong> Opit, miten noitaprofiilisi vaikuttaa rituaalisi rakenteeseen ja sisältöön. Vihreä noita saattaa keskittyä luontoon, kun taas varjonoita syvennyy varjotyöhön.</li>
                        <li><strong>Käytännön harjoittelu:</strong> Luomme yhdessä sinun ensimmäisen henkilökohtaisen rituaalisi ja harjoittelemme sen suorittamista.</li>
                      </ul>
                      <div className="module-highlight">
                        <strong>✨ Tämä moduuli on kurssin sydän ja antaa sinulle työkalut luoda noituuden, joka on todella sinun.</strong>
                      </div>
                    </div>
                  </div>

                  <div className="module card">
                    <div className="module-header">
                      <span className="module-number">5</span>
                      <h3>ELÄVÄ NOITUUS</h3>
                    </div>
                    <div className="module-content">
                      <p>
                        Viimeisessä moduulissa keskitymme siihen, miten noituus elää arjessa. Opimme integroimaan noituuden osaksi päivittäistä elämäämme ja ymmärrämme, mitä noituus todella tarkoittaa käytännössä.
                      </p>
                      <h4>Moduulin sisältö:</h4>
                      <ul>
                        <li><strong>Noituus arjessa:</strong> Opimme, miten noituus näkyy päivittäisessä elämässä. Noituus ei ole vain rituaaleja, vaan tapa elää ja olla maailmassa.</li>
                        <li><strong>Rajat ja vastuu:</strong> Keskustellaan noituuden eettisyydestä, rajoista ja vastuusta. Opimme, miten työskennellä energian kanssa turvallisesti ja eettisesti.</li>
                        <li><strong>Intuition kehittäminen:</strong> Opimme luottamaan omaan intuitioomme ja tunnistamaan, milloin se puhuu meille.</li>
                        <li><strong>Noituus identiteettinä:</strong> Ymmärrämme, että noituus on osa sinua, ei suoritus. Sinä olet jo noita – tarvitset vain muistaa, millainen noita olet.</li>
                        <li><strong>Jatkuva oppiminen:</strong> Opimme, miten jatkaa noituuspolkua kurssin jälkeen ja miten kehittää omaa noituuttasi.</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="course-core card">
                  <h3>✨ Kurssin ydinsanoma</h3>
                  <p className="core-message">
                    "Sinusta ei tule noitaa – sinä muistat, millainen noita olet."
                  </p>
                  <p className="core-explanation">
                    Tämä kurssi ei opeta sinua olemaan noita. Sen sijaan se auttaa sinua muistamaan ja ymmärtämään, millainen noita jo olet. Jokaisella on oma polkunsa ja oma tapa lähestyä noituutta. Tämä kurssi antaa sinulle työkalut löytää oma polkusi ja elää noituutta autenttisesti.
                  </p>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default WitchProfile;
